export default __webpack_public_path__ + "static/media/Justera_Logo-04-1.e4e70412.png";